import styled from 'styled-components';

const ContainerStyles = styled.div`
  position: relative;
  width: 100%;
  margin: 0px auto;
  padding: 30px 20px;
`;

export { ContainerStyles };
